import { apiSlice } from "../apiSlice";
import { STUDENTS_URL } from "../../constants";

export const studentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      login: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/login`,
          method: 'POST',
          body: data,
        }),
      }),
      register: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/register`,
          method: 'POST',
          body: data,
        }),
      }),
      logout: builder.mutation({
        query: () => ({
          url: `${STUDENTS_URL}/logout`,
          method: 'POST',
        }),
      }),
      profile: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/profile`,
          method: 'PUT',
          body: data,
        }),
      }),
      getProfile: builder.query({
        query: () => ({
          url: `${STUDENTS_URL}/profile`,
        }),
        invalidatesTags: ['Students'], // Invalidate 'Profile' cache upon success
      }),
      
      subscribe: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/subscribestudent`,
          method: 'PUT',
          body: data,
        }),
      }),
      update: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/subscribeupdatestudent`,
          method: 'POST',
          body: data,
        }),
      }),
      subscribeinstripe: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/subscribeinstripe`,
          method: 'POST',
          body: data,
        }),
      }),
      cancelstripesubscription: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/cancelstripesubscription`,
          method: 'POST',
          body: data,
        }),
      }),
      checkstripesubscription: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/checkstripesubscription`,
          method: 'POST',
          body: data,
        }),
      }),
      checkstripeupgradesubscription: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/checkstripeupgradesubscription`,
          method: 'POST',
          body: data,
        }),
      }),
      upgradestripesubscription: builder.mutation({
        query: (data) => ({
          url: `${STUDENTS_URL}/upgradestripesubscription`,
          method: 'POST',
          body: data,
        }),
      }),
      studentSubjects: builder.query({
        query: ({ pageNumber }) => ({
          url: `${STUDENTS_URL}/studentsubjects`,
          params: {
            pageNumber,
        },
        }),
      }),


      checksubscriptionisActive: builder.query({
        query: () => ({
          url: `${STUDENTS_URL}/checksubscriptionisactive`,        
        }),
      }),


      studentmySubjects: builder.query({
        query: ({ pageNumber }) => ({
          url: `${STUDENTS_URL}/studentmysubjects`,
          params: {
            pageNumber,
          },
        }),
      }),
      StudentmySubscriptions: builder.query({
        query: ({ pageNumber }) => ({
          url: `${STUDENTS_URL}/studentmysubscriptions`,
          params: {
            pageNumber,
        },
        }),
      }),
      studentTeachers: builder.query({
        query: ({ pageNumber }) => ({
          url: `${STUDENTS_URL}/studentteachers`,
          params: {
            pageNumber,
        },
        }),
        
      }),
    }),
});

export const { 
  useLoginMutation, 
  useLogoutMutation, 
  useRegisterMutation,
  useProfileMutation,
  useSubscribeMutation,
  useSubscribeinstripeMutation,
  useUpdateMutation,
  useStudentSubjectsQuery,
  useGetProfileQuery,
  useChecksubscriptionisActiveQuery,
  useUpgradestripesubscriptionMutation,
  useCheckstripesubscriptionMutation,
  useCancelstripesubscriptionMutation,
  useCheckstripeupgradesubscriptionMutation,
  useStudentmySubjectsQuery,
  useStudentmySubscriptionsQuery,
  useStudentTeachersQuery
  
} = studentApiSlice;
